
//import firebase from "firebase";
//import {auth, functions, } from "@/scripts/firebase";
//import {MailActionLinkParams } from "@/scripts/datatypes";
import { Component, Mixins } from "vue-property-decorator";
import Common from '../mixins/common';
//import { PDFDocument, rgb } from 'pdf-lib'
//import fontkit from '@pdf-lib/fontkit'

@Component({
  components: {
  
  }
})

export default class Home extends Mixins(Common) {

  async created(){
    console.trace('created')
   
    console.log(this.$router)
    try{
      //console.log(this.$store.getters.schoolId)

      //const PublicProfileDocRef = this.$getUserPublicProfileDocRef('ZixML6C5KDdNj9r7KwVd35H1s6h2',"uUZKCYbbbvOtRcS3fwQH")
// /schools/uUZKCYbbbvOtRcS3fwQH/classes/
//console.log(PublicProfileDocRef)
console.log(this.$store.getters.schoolId)
//console.log(this.$getClassesColRef())
/*
const data = await this.$getClassesColRef("uUZKCYbbbvOtRcS3fwQH"),where(firestore.FieldPath.documentId(), '==','sQisZYWXwFdXHaaPTPtZ').get()
  const d = data.docs[0].data()
console.log(PublicProfileDocRef.firestore)

    console.log(d.memberMeta['ZixML6C5KDdNj9r7KwVd35H1s6h2'].ref.path)
    console.log(PublicProfileDocRef.isEqual(d.memberMeta['ZixML6C5KDdNj9r7KwVd35H1s6h2'].ref))
    */
    }catch(error){
      console.log(error)
    }
  }

  async sendGrid(){
    //const sendSMS = httpsCallable(functions,'sendEmailBySendGrid');
    //await sendSMS({body: 'sendgrid送信テスト'})

  }

  destroyed() {
//
}
  /**
   * サーバー側でやる
   * クライアント側ではやっぱり無理
   * phpがいいかも
   * htmlでpdf
   * https://tcpdf.org/
   * https://www.setasign.com/products/fpdi/demos/tcpdf-demo/#p-267
   */
  /*
  async downloadPDF(){
    try{
   const url = 'http://localhost:8080/ipaexg.ttf' //ipaexg.ttf
   const fontBytes = await fetch(url).then(res => res.arrayBuffer())

    // Create a new PDFDocument
const pdfDoc = await PDFDocument.create()

    pdfDoc.registerFontkit(fontkit)
  const customFont = await pdfDoc.embedFont(fontBytes)


// Add a blank page to the document
const page = pdfDoc.addPage()

const text = '今日はいい点でキスSome fancy Unicode text in the ŪЬȕǹƚü font'
  const textSize = 24
  
  page.drawText(text, {
    x: 40,
    y: 450,
    size: textSize,
    font: customFont,
    color: rgb(0, 0.53, 0.71),
  })
 

const pdfDataUri = await pdfDoc.saveAsBase64({ dataUri: true });

const link = document.createElement('a')
link.href = pdfDataUri
    link.download = 'Result.pdf'
    link.click()

    }catch(error){
      console.log(error)
    }
  }
  */
}
